// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._189ee4h9{border-width:var(--ds-border-width,1px)}\n._1dqogq9o{border-style:dashed}\n._1h6dmuej{border-color:var(--ds-border,#091e4224)}\n._19bvutpp{padding-left:var(--ds-space-150,9pt)}\n._19pkze3t{margin-top:var(--ds-space-0,0)}\n._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._ca0qutpp{padding-top:var(--ds-space-150,9pt)}\n._n3tdutpp{padding-bottom:var(--ds-space-150,9pt)}\n._u5f3utpp{padding-right:var(--ds-space-150,9pt)}", ""]);
// Exports
module.exports = exports;
